<template>
  <div class="container">
    <van-nav-bar
      title="统计分析"
      left-text="" 
      left-arrow 
      @click-left="onClickLeft"
    />
    <van-tabs
      color="#2FAAFF"
      title-inactive-color="#474542"
      title-active-color="#2FAAFF"
      v-model="tab_active" 
      swipeable>
      <van-tab title="设备运行统计">
        <div class="main">
          <div class="title">基础数据</div>
          <div class="menu-box">
            <div class="menu-item">
              <div class="lab">在管项目</div>
              <div class="val">{{baseData.communityCount}}</div>
            </div>
            <div class="menu-item">
              <div class="lab">设备总数/插座总数</div>
              <div class="val">{{baseData.deviceCount}}/{{baseData.deviceLoopCount}}</div>
            </div>
            <div class="menu-item">
              <div class="lab">在线率</div>
              <div class="val">{{baseData.deviceOnlinesPercent}}</div>
            </div>
            <div class="menu-item">
              <div class="lab">使用率</div>
              <div class="val">{{baseData.deviceLoopPercent}}</div>
            </div>
            
          </div>

          <div class="borBox">
            <div class="title">设备状态</div>
            <div class="flex">
              <div class="echartBox">
                <div class="echart">
                  <div class="echart_panel">
                    <div id="pieEchart1" style="width: 86px;height: 86px;"></div>
                  </div>
                  <div class="echart_rate">
                    <div class="name">{{typeWarnObj.name}}</div>
                    <div :class="typeWarnObj.color+' val'">{{ typeWarnObj.rate }}%</div>
                  </div>
                  <img src="../assets/img/chartbg.png" />
                </div>
              </div>
              <div class="stateList" v-if="statusList[0]">
                <div class="item">
                  <span class="dian bg_b"></span>
                  <span class="lab">在线</span>
                  <span class="val">{{statusList[0].value}}个</span>
                  <span class="bfb">{{statusList[0].bfb}}%</span>
                </div>
                <div class="item">
                  <span class="dian bg_c"></span>
                  <span class="lab">离线</span>
                  <span class="val">{{statusList[1].value}}个</span>
                  <span class="bfb">{{statusList[1].bfb}}%</span>
                </div>
                <div class="item">
                  <span class="dian bg_r"></span>
                  <span class="lab">故障</span>
                  <span class="val">{{statusList[2].value}}个</span>
                  <span class="bfb">{{statusList[2].bfb}}%</span>
                </div>
              </div>
            </div>
          </div>

          <div class="borBox">
            <div class="row">
              <span class="col">项目名称</span>
              <span class="col">设备数量</span>
              <span class="col">使用率</span>
              <span class="col">在线率</span>
            </div>
            <div class="row" :key="index" v-for="(item,index) in tableList">
              <span class="col">{{item.communityName}}</span>
              <span class="col">{{item.deviceCount}}</span>
              <span class="col">{{item.deviceLoopPercent}}</span>
              <span class="col">{{item.deviceOnlinesPercent}}</span>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="设备告警统计">
        <div class="main">
          <div class="title">告警统计</div>
          <div class="btnbox flex">
            <div @click="changeTime(1)" :class="warnActive == 1?'item btnActive':'item'">24小时</div>
            <div @click="changeTime(2)" :class="warnActive == 2?'item btnActive':'item'">48小时</div>
            <div @click="changeTime(3)" :class="warnActive == 3?'item btnActive':'item'">超过48小时</div>
          </div>
          <div class="menu-box">
            <div class="menu-item2" @click="changePage('')">
              <div class="lab">告警总数</div>
              <div class="val">{{warnData.warningAllCount}}</div>
            </div>
            <div class="menu-item2" @click="changePage(2)">
              <div class="lab">插座故障</div>
              <div class="val">{{warnData.loopFaultCount}}</div>
            </div>
            <div class="menu-item2" @click="changePage(1)">
              <div class="lab">电流过大</div>
              <div class="val">{{warnData.excessiveCurrentCount}}</div>
            </div>
            <div class="menu-item2" @click="changePage(5)">
              <div class="lab">短路</div>
              <div class="val">{{warnData.shortCircuitCount}}</div>
            </div>
            <div class="menu-item2" @click="changePage(4)">
              <div class="lab">回路异常</div>
              <div class="val">{{warnData.mainboardExceptionCount}}</div>
            </div>
            
          </div>

          <div class="borBox">
            <div class="row">
              <span class="col2">项目名称</span>
              <span class="col2">告警原因</span>
              <span class="col2">数量</span>
            </div>
            <div class="row" :key="index" v-for="(item,index) in warnData.pageList">
              <span class="col2">{{item.communityName}}</span>
              <span class="col2">{{item.reasonDesc}}</span>
              <span class="col2">{{item.count}}</span>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    
    
  </div>
</template>

<script>
  import moment from "moment";
  import axios from '@/axios.js';
  import {NavBar,Icon,Grid,GridItem,Image,Swipe,SwipeItem,Toast,Loading,Popup,Tabbar,TabbarItem,Tab,Tabs} from 'vant';
  export default {
    data() {
      return {
        tab_active: 0,
        baseData: {},
        statusObj: {},
        statusList: [],
        tableList: [],
        typeWarnObj: {
          name: "在线",
          color: "col_b",
          rate: "0",
        },
        colorArr: [
          "#5BA7FC",
          "#A3A1A1",
          "#FF7677",
          "#FFEE68",
        ],
        colClassArr:['col_b','col_c','col_r','col_y'],
        pieEchartTimer:'',
        startTime: moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"),
        endTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        warnData:'',
        warnActive: 1,
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Grid.name]:Grid,
      [GridItem.name]:GridItem,
      [Image.name]:Image,
      [Swipe.name]:Swipe,
      [SwipeItem.name]:SwipeItem,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,  
      [Popup.name]:Popup,
      [Tabbar.name]:Tabbar,
      [TabbarItem.name]:TabbarItem,
      [Tab.name]:Tab,
      [Tabs.name]:Tabs,
    },
    methods: {
      changePage(type){
        this.$router.replace({path: 'warn.html',query:{warningReason:type,}})
      },
      getFloat(num,sum){
        if(num == 0){
          return 0
        }else{
          return ((num/sum)*100).toFixed(1);
        }
      },
      initPieChart(value) {
        let myChart = this.$echarts.init(document.getElementById('pieEchart1'));
        myChart.setOption({
          backgroundColor: "",
          series: [
            {
              name: "访问来源",
              hoverAnimation: false,
              type: "pie",
              radius: ["70%", "100%"],
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: "20",
                  formatter: "{d}%",
                },
              },
              labelLine: {
                show: false,
              },
              data: value,
              itemStyle: {
                borderWidth: 3,
                borderColor: "#000131",
                normal: {
                  color: (params) => {
                    return this.colorArr[params.dataIndex];
                  },
                },
              },
            },
          ],
        });
      },
      runTypeWarn(newData){
        if (this.pieEchartTimer) {
          clearInterval(this.pieEchartTimer);
        }
        // 标识定时器增长变量，初始为零
        let indexFlag = 0;
        let facility = newData;
        // 获取报警总数
        // let warnSum = 0;
        // facility.forEach((item) => {
        //   warnSum += item.value;
        // });
        // 初始化echart饼图
        this.initPieChart(facility);
        // 初始化数据，饼图中心百分比，饼图下面对应的图标颜色和值（饼图中心百分比是自己定位上去，不是echart自带）
        this.typeWarnObj.name = facility[0].name;
        this.typeWarnObj.color = this.colClassArr[0];
        this.typeWarnObj.rate = facility[0].bfb;
        // 获取分类数据的个数
        let warnTypeLength = facility.length;
        this.pieEchartTimer = setInterval(() => {
          // 根据定时器更新分类name、color、rate
          if (indexFlag < warnTypeLength) {
            this.typeWarnObj.name = facility[indexFlag].name;
            this.typeWarnObj.color = this.colClassArr[indexFlag];
            this.typeWarnObj.rate = facility[indexFlag].bfb;
          }
          indexFlag++;
          if (indexFlag == warnTypeLength) {
            indexFlag = 0;
          }
        }, 3000);

      },
      getDashBoard() {
        //基础数据
        axios.get("/dashboard/devicebaseaggregate",{
        }).then((res)=>{
          this.baseData = res.data;
        })
        //设备状态
        axios.get("/dashboard/devicestatusaggregate",{
        }).then((res)=>{
          this.statusList = [
            { value: res.data.data.onlines, name: "在线" },
            { value: res.data.data.offlines, name: "离线" },
            { value: res.data.data.unInstalls, name: "故障" }
          ]
          this.statusList.forEach(item=>{
            item.bfb = this.getFloat(item.value,res.data.data.sum);
          })
          this.runTypeWarn(this.statusList);
        })
        //设备状态
        axios.get("/dashboard/devicelist",{
        }).then((res)=>{
          this.tableList = res.data;
        })
      },
      changeTime(type){
        this.warnActive = type;
        if(type == 1){
          this.startTime = moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00");
          this.endTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        }else if(type == 2){
          this.startTime = moment().subtract(2, "days").format("YYYY-MM-DD 00:00:00");
          this.endTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        }else{
          this.startTime = '';
          this.endTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        }
        this.getWarnData();
      },
      getWarnData() {
        //告警数据
        axios.post("/dashboard/devicewarningaggregate",{
          pageIndex: 0,
          pageSize: 999,
          filter: {
            startTime: this.startTime,
            endTime: this.endTime
          }
        }).then((res)=>{
          this.warnData = res.data;
        })
      },
      onClickLeft() {
        this.$router.go(-1);
      },
    },
    computed:{
    },
    created () {
      this.getDashBoard();
      this.getWarnData();
    },
    mounted () {
      
    },
    beforeDestroy(){
      clearInterval(this.pieEchartTimer);
    },
    destroyed () {}
  }
</script>

<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;
  }
  .main{padding: 0 18px 10px 18px;}
  .title{
    font-weight: bold;
    font-size: 14px;
    color: #373737;
    margin-top: 16px;
  }
  .menu-box{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    padding-top: 16px;
    .menu-item,.menu-item2{
      width: 48%; 
      margin-bottom: 20px; 
      padding: 16px;
      border-radius: 6px;
      background: #fff;
      overflow: hidden;
      vertical-align: middle;
      font-size: 14px;
      .lab{
        font-weight: bold;
        line-height: 30px;
        color: #373737;
      }
      .val{color: #9A9A9A;}
    }
    .menu-item:nth-child(1){
      background: url(../assets/img/tj1.png) no-repeat;
      background-size: 100% 100%;
    }
    .menu-item:nth-child(2){
      background: url(../assets/img/tj2.png) no-repeat;
      background-size: 100% 100%;
    }
    .menu-item:nth-child(3){
      background: url(../assets/img/tj3.png) no-repeat;
      background-size: 100% 100%;
    }
    .menu-item:nth-child(4){
      background: url(../assets/img/tj4.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .flex{
    display: flex;
    justify-content: space-between;
  }
  .borBox{
    width: 100%;
    padding: 15px 0;
    margin-bottom: 20px;
    font-size: 13px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 2px 8px 2px rgba(100,149,208,0.09); 
    .title{
      font-weight: bold;
      font-size: 14px;
      color: #373737;
      margin: 0 0 20px 10px;
    }
  }

  .borBox .echartBox{
    width: 40%;
    text-align: center;
    .echart{
      width: 100px;
      height: 100px;
      margin: 5px auto 0 auto;
      position: relative;
      .echart_panel{
        width: 95rpx;
        height: 95rpx;
        position: absolute;
        left: 7px;
        top: 7px;
        z-index: 10;
      }
      .echart_rate{
        width: 100px;
        height: 100px;
        font-size: 11px;
        text-align: center;
        position: absolute;
        left: 0;
        top: 0;
        .name{
          padding: 33px 0 2px 0;
        }
      }
      img{
        width: 100px;
        height: 100px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 0;
      }
    }
  }
  .borBox .stateList{
    width: 60%;
    font-size: 14px;
    .item{
      margin: 4px 0;
      .lab{
        width: 50px;
        display: inline-block;
        margin: 0 6px 0 6px;
      }
      .val{
        min-width: 60px;
        display: inline-block;
      }
      .dian{
        width: 6px;
        height: 6px;
        margin-bottom: 2px;
        border-radius: 6px;
        display: inline-block;
      }
    }
  }

  .borBox .row{
    margin-bottom: 12px;
  }
  .borBox .row:nth-child(1){
    font-weight: bold;
  }
  .borBox .col{
    width: 20%;
    display: inline-block;
    text-align: center;
  }
  .borBox .col2{
    width: 33%;
    display: inline-block;
    text-align: center;
  }
  .borBox .col:nth-child(1){
    width: 30%;
  }
  .borBox .col:nth-child(2){
    width: 30%;
  }

  .btnbox{
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    .item{
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 6px;
      background: #fff;
    }
  }
  .btnActive{
    background: #5BA7FC !important;
    color: #fff;
  }

</style>
